import React from 'react';
import PropTypes from 'prop-types';
import {TextField} from 'rmwc';
import {Snackbar} from 'rmwc';

import * as styles from '../../styles';
import * as actions from './actions';
import {request} from '../../containers/actions';
import {fetchUser} from '../../containers/actions';


export default class CellPhone extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        cellphone: this.context.user ? this.context.user.cell_phone || '' : '',
        verificationCode: '',
        verificationCounter: 0,
    };

    async save() {
        try {
            if (this.state.verify) {
                this.setState({successful: false});
                this.context.store.dispatch(actions.setErrors(
                    {},
                    this.props.store.get('elementId'),
                ));
                const payload = {
                    verification_code: this.state.verificationCode,
                };
                await this.context.store.dispatch(request({
                    path: `/user/${this.context.user.id}/verify_cell_phone/`,
                    body: payload,
                    method: 'PATCH',
                }));
                await this.context.store.dispatch(fetchUser());
                setTimeout(
                    () => this.setState({
                        cellphone: this.context.user ? this.context.user.cell_phone || '' : '',
                        verify: false,
                        successful: true,
                        verificationCounter: 0,
                    }),
                    0,
                );
            }
            else {
                this.context.store.dispatch(actions.setErrors(
                    {},
                    this.props.store.get('elementId'),
                ));
                const payload = {
                    cell_phone: this.state.cellphone,
                };
                await this.context.store.dispatch(request({
                    path: `/user/${this.context.user.id}/set_cell_phone/`,
                    body: payload,
                    method: 'PATCH',
                }));
                await this.context.store.dispatch(fetchUser());
                setTimeout(
                    () => this.setState({
                        cellphone: this.context.user ? this.context.user.cell_phone || '' : '',
                        verify: true,
                        sent: true,
                        verificationCounter: 0,
                    }),
                    0,
                );
            }
            return true;
        }
        catch (exception) {
            this.context.store.dispatch(actions.setErrors(
                exception,
                this.props.store.get('elementId'),
            ));
            this.setState({
                cellphone: this.context.user ? this.context.user.cell_phone || '' : '',
                successful: false,
                ...this.state.verificationCounter >= 2
                    ? {verify: false}
                    : {verificationCounter: this.state.verificationCounter + 1},
            });
            return false;
        }
    }

    render() {
        return <form
            style={{width: '20em', margin: 'auto'}}
            onSubmit={event => {
                if (!this.state.cellphone)
                    return;
                this.save.bind(this)();
                event.preventDefault();
            }}>
            <Snackbar
                show={this.state.sent}
                onClose={() => this.setState({sent: false})}
                message={window.gettext('Verification code sent to your cell phone.')}
            />
            <div
                style={{
                    marginTop: '.5em',
                    color: this.context.user.cell_phone
                        ? this.context.user.cell_phone_verified ? styles.successColor : styles.alertColor
                        : styles.warningColor,
                    backgroundColor: this.context.user.cell_phone
                        ? this.context.user.cell_phone_verified ? styles.successBackColor : styles.alertBackColor
                        : styles.warningBackColor,
                    borderStyle: 'solid',
                    borderWidth: '.0625em',
                    borderColor: this.context.user.cell_phone
                        ? this.context.user.cell_phone_verified ? styles.successBorderColor : styles.alertBorderColor
                        : styles.warningBorderColor,
                }}>
                {this.context.user.cell_phone
                    ? this.context.user.cell_phone_verified
                        ? window.gettext('Your cell phone is verified.')
                        : window.gettext('Your cell phone is not verified.')
                    : window.gettext('Enter your cell phone.')
                }
            </div>
            <div style={{...styles.error, marginTop: '1em'}}>
                {this.props.store.getIn(['errors', 'detail'])
                    ? <li style={{display: 'block'}}>
                        * {this.props.store.getIn(['errors', 'detail'])}
                    </li>
                    : null
                }
            </div>
            <div
                style={{
                    float: 'right',
                    clear: 'right',
                    width: '100%',
                }}>
                <TextField
                    rootProps={{style: {width: '100%', lineHeight: '1.2em'}}}
                    outlined
                    label={window.gettext('Cell phone number')}
                    value={this.state.cellphone.persian()}
                    disabled={this.state.verify}
                    onChange={
                        ({target: {value}}) => this.setState({cellphone: value.english()})
                    }
                />
                <div style={styles.error}>
                    {this.props.store.getIn(['errors', 'cell_phone'])
                        ? this.props.store.getIn(['errors', 'cell_phone']).map(
                            (error, index) => <li style={{display: 'block'}} key={index}>
                                * {error}
                            </li>,
                        )
                        : null
                    }
                </div>
                {this.state.verify
                    ? <span>
                        <TextField
                            rootProps={{style: {width: '100%', lineHeight: '1.2em'}}}
                            outlined
                            label={window.gettext('Verification code')}
                            value={this.state.verificationCode}
                            onChange={
                                ({target: {value}}) => {
                                    this.setState({verificationCode: value.english()});
                                }
                            }
                        />
                        <div style={styles.error}>
                            {this.props.store.getIn(['errors', 'verification_code'])
                                ? this.props.store.getIn(['errors', 'verification_code']).map(
                                    (error, index) => <li style={{display: 'block'}} key={index}>
                                        * {error}
                                    </li>,
                                )
                                : null
                            }
                        </div>
                    </span>
                    : null
                }
            </div>
            <div style={styles.dialogButtonContainer}>
                <button
                    style={{
                        ...styles.button,
                        color: this.state.verify
                            ? !this.state.verificationCode ? '#9a9a9a' : styles.button.color
                            : !this.state.cellphone || this.state.cellphone === this.context.user.cell_phone ? '#9a9a9a' : styles.button.color,
                    }}
                    type='submit'
                    disabled={this.state.verify
                        ? !this.state.verificationCode
                        : (
                            !this.state.cellphone ||
                            this.state.cellphone === this.context.user.cell_phone && this.context.user.cell_phone_verified
                        )
                    }>
                    {this.state.verify
                        ? window.gettext('Verify')
                        : this.context.user.cell_phone
                            ? this.context.user.cell_phone_verified
                                ? window.gettext('Change')
                                : window.gettext('Verify cell phone number')
                            : window.gettext('Apply')
                    }
                </button>
                {this.state.verify
                    ? <button
                        style={{...styles.button, marginRight: '.5em'}}
                        onClick={() => this.setState({verify: false})}>
                        {window.gettext('Change number')}
                    </button>
                    : null
                }
            </div>
        </form>;
    }
}
